export const GET_TWO_FACTOR_AUTH_WATCHER =
  "app/Security/GET_TWO_FACTOR_AUTH_WATCHER"

export const GET_TWO_FACTOR_AUTH_SUCESS =
  "app/Security/GET_TWO_FACTOR_AUTH_SUCESS"

export const PUT_TWO_FACTOR_AUTH_WATCHER =
  "app/Security/PUT_TWO_FACTOR_AUTH_WATCHER"

export const PUT_TWO_FACTOR_AUTH_ACTIVE =
  "app/Security/PUT_TWO_FACTOR_AUTH_ACTIVE"

export const PUT_TWO_FACTOR_AUTH_ACTIVE_SUCESS =
  "app/Security/PUT_TWO_FACTOR_AUTH_ACTIVE_SUCESS"
